export default __webpack_public_path__ + "static/media/a018-8.ad93bbb3.svg";